module.exports = __webpack_public_path__ + "static/media/logo_2.913ef78d.png";